import { Schema } from 'rsuite';
import {
  companyNameValidation,
  emailValidation,
  nameValidation,
  phoneRequiredValidation,
  requiredValidation,
} from 'src/common/validation';
import SchemaTyped from 'rsuite/esm/Schema';
import { FormModelPerson } from 'src/types/person';

const { BooleanType } = SchemaTyped.Types;

export const FormValuesPerson = Schema.Model<FormModelPerson>({
  firstName: nameValidation,
  lastName: nameValidation,
  companyName: companyNameValidation,
  email: emailValidation,
  phone: phoneRequiredValidation,
  mailingAddress: requiredValidation,
  sameAsPropertyAddress: BooleanType(),
});
